import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/app/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
